import { Directive } from 'vue';

export const IsOverflowing: Directive = (el, binding) => {
  const { offsetWidth, scrollWidth } = el;
  binding.value(offsetWidth < scrollWidth);
};
